























































































import { Vue, Component } from 'vue-property-decorator';

import esignLogo from '@/assets/logos/logo_esign_white.svg';
import trustBankLogo from '@/assets/logos/logo_trust_bank.svg';
import scalaLogo from '@/assets/logos/logo_scala.svg';
import fujiSoftLogo from '@/assets/logos/logo_fujisoft.jpg';
import layerxLogo from '@/assets/logos/logo_layer_x.png';
import voteforLogo from '@/assets/logos/logo_vote_for.png';
import sevenBankLogo from '@/assets/logos/logo_seven_bank.jpg';
import monstarlabLogo from '@/assets/logos/logo_monstarlab.png';

@Component({
  name: 'PartnerSection',
  components: {
  },
})
/**
 * @vuese
 * @group Page/PartnerSection
 * PartnerSection component
 */
export default class PartnerSection extends Vue {
  // [data]
  esignLogo: string = esignLogo;
  trustBankLogo: string = trustBankLogo;
  scalaLogo: string = scalaLogo;
  fujiSoftLogo: string = fujiSoftLogo;
  layerxLogo: string = layerxLogo;
  voteforLogo: string = voteforLogo;
  sevenBankLogo: string = sevenBankLogo;
  monstarlabLogo: string = monstarlabLogo;
}
